export const ActivityFeed = `
<rect width='682.667' height='170.667' transform='translate(341.333 ${0 + 87})'/>
<rect width='158.476' height='170.667' transform='translate(0 ${0 + 87})'/>
<rect width='682.667' height='170.667' transform='translate(341.333 ${341.333 + 87})'/>
<rect width='158.476' height='170.667' transform='translate(0 ${341.333 + 87})'/>
<rect width='682.667' height='170.667' transform='translate(341.333 ${682.667 + 87})'/>
<rect width='158.476' height='170.667' transform='translate(0 ${682.667 + 87})'/>
`;



// WEBPACK FOOTER //
// ./src/js/core-components/svg-menu-icons/icons/activityFeed.js